import React, {FC} from 'react';
import {useFormik} from 'formik';
import cnBind from 'classnames/bind';
import {useStoreon} from 'storeon/react';
import dayjs from 'dayjs';
import {GxButton, GxForm, GxInput} from '@garpix/garpix-web-components-react';
import styles from './styles/index.module.scss';
import Radio from '../../../../components/Radio';
import {PAYMENT_RETURN_PAY_ITEMS} from '../ModalOrder/const';
import InputNumbers from '../../../../components/InputNumbers';
import {ORDERS} from '../../../../const';
import ModalLayout from '../../../../components/ModalLayout';
import {NAME_TYPES_CERTIFICATE, TYPES_CERTIFICATE} from '../../../Certificates/const';
import {returnCertificate} from '../../helpers';

interface IReturnCertificate {
    flag: boolean;
    onRequestClose: () => void;
    data: Record<string, any>,
    userInfo: Record<string, any> | null,
    userID: number
}

const ReturnCertificate: FC<IReturnCertificate> = ({onRequestClose,flag,data,userInfo,userID}) => {
    const cn = cnBind.bind(styles);
    const {
        current_price_by_equivalent,
        side,
        remaining_minutes_fly,
        remaining_sets_wave,
        remaining_rent_pays,
        status,
        pay_order_created_at,
        pay_order_id,
        id
    } = data.data;

    const {dispatch} = useStoreon()
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {amount:current_price_by_equivalent, comment: '',return_method: null, date: null},
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: async (values) => {
            if (values.return_method === null) {
                return
            }

            try{
                await returnCertificate({
                    certificate_id:id,
                    return_method: values.return_method,
                    comment: values.comment
                });
                dispatch('certificatesUser/get', { customer_id: userID, page: 1, side, limit: 7 })
                onRequestClose();
            }catch (e) {
                console.log(e);
            }
        }
    });

    const disabledReturn = formik.values.return_method === null || TYPES_CERTIFICATE[status] === 'USED' || TYPES_CERTIFICATE[status] === 'RETURN'
    const isHybrid = side !== ORDERS.PIPE && side !== ORDERS.WAVE;
    const isRent = side === ORDERS.WAVE && remaining_rent_pays > 0;

    let resourceText = '—';

    if (isHybrid) {
        const parts = [];
        if (remaining_minutes_fly) parts.push(`${remaining_minutes_fly} мин.`);
        if (remaining_sets_wave) parts.push(`${remaining_sets_wave} сет(ов)`);
        resourceText = parts.join(' ') || '—';
    } else if (isRent) {
        resourceText = `${remaining_rent_pays} ар.`;
    } else if (side === ORDERS.PIPE) {
        resourceText = `${remaining_minutes_fly} мин.`;
    } else if (side === ORDERS.WAVE) {
        resourceText = `${remaining_sets_wave} сет(ов)`;
    }

    return (
      <ModalLayout
        flag={flag}
        onClose={onRequestClose}
      >
          <div className={styles['header']}>
              <h2 className={styles['header--title']}>Возврат средств. Счет №{pay_order_id}</h2>
              <div className={styles['header--info']}>
                  <span>Кому: {userInfo ? userInfo.last_name : ''} {userInfo ? userInfo.first_name : ''} </span>
                  <span
                    className={
                        cn(styles['status'],
                          styles[`status_${NAME_TYPES_CERTIFICATE[TYPES_CERTIFICATE[status]].class}`])
                    }
                  >
                                            {NAME_TYPES_CERTIFICATE[TYPES_CERTIFICATE[status]].title}
                                          </span>
              </div>
          </div>

        <GxForm onGx-submit={formik.submitForm}>
            <div className={styles['subheader']}>
                <span className={styles['subheader--subtitle']}>Способ возврата:</span>
            </div>
            <div className={styles['actions']}>
                {PAYMENT_RETURN_PAY_ITEMS
                    // .filter((item) => (is_pay_here || certificate_name || deposit_name) ? item.id !== RETURN_PAY_TYPES.ONLINE : true)
                    .map((item) => (
                        <Radio
                            key={item.id}
                            name="return_method" className={styles['actions--item']}
                            checked={formik.values.return_method === item.id}
                            onClick={() => formik.setFieldValue('return_method', item.id)}>
                            {item.title}
                        </Radio>
                    ))}
            </div>
            <div className={styles['wrap-group']}>
                <div className={styles['group']}>
                    <InputNumbers
                      label='Сумма возврата:'
                      name="amount"
                      value={formik.values.amount}
                      disabled
                      className={cn({
                          'group--input': true,
                          'group--input--error': formik.errors.amount
                      })}
                      type='number'
                    />
                    <span className={styles['symbol--price']}/>
                    <p className={styles['group--error']}>{formik.errors.amount}</p>
                </div>
                <div className={styles['group']}>
                    <GxInput
                      label='Примечание:'
                      name="comment"
                      onGx-change={(e: Record<string, any>) => {
                          formik.setFieldValue('comment', e.target.value);
                      }}
                      className={cn(styles['group--input'])}
                    />
                </div>
            </div>
            <div className={styles['footer']}>
                <div className={styles['footer--left-block']}>
                    <div className={styles['pay-info']}>
                        <div className={cn(styles['pay-info__item'], styles['pay-info__item_paid'])}>
                            <p className={styles['pay-info__item_label']}>Оставшийся ресурс:</p>
                            <p>{resourceText}</p>
                        </div>
                    </div>
                </div>
                <div className={styles['time']}>
                    <p className={styles['time--info']}>Дата создания счета:</p>
                    <p className={styles['time--date']}>{pay_order_created_at && dayjs(pay_order_created_at).format('YYYY-MM-DD HH:mm')}</p>
                </div>
                <div className={styles['footer--right-block']}>
                    <GxButton className={styles['btn--gray']} onClick={onRequestClose}>
                        Отмена
                    </GxButton>
                    <GxButton className={styles['btn--default']} type='submit' disabled={disabledReturn}>
                        Вернуть
                    </GxButton>
                </div>
            </div>
        </GxForm>
        </ModalLayout>
    );
};

export default ReturnCertificate;